/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import type Form from 'forms/_.extend';
import RequireForAccess from 'react-access';
import { assetRequestAdmins } from '../../../../../permissions/general';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AddNewCompanyForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, accountStore }: TypeProps = this.props;
    const form: Form = this.props.form;

    // Show Location Type if EITHER flag is enabled.
    // Keeps the 'rental' guard; remove it if you want always-on UI.
    const details = accountStore && accountStore.details && accountStore.details.details;
    const assetRequestEnabled = !!(details && details.asset_request_form_enabled);
    const rushCustomerEnabled = !!(details && details.is_rush_asset_request_form_customer);

    const showLocationType =
      accountStore.searchType !== 'rental' && (assetRequestEnabled || rushCustomerEnabled);

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true}>
            <ElectroTextField field={form.$('addCompanyForm.company')} />

            {showLocationType && (
              <RequireForAccess permissions={assetRequestAdmins}>
                <FormControl>
                  <FormLabel className={styles['form-label']}>
                    {form.$('locationRequestFormType.list').label}
                  </FormLabel>

                  {/* Keep Radio state consistent: compare/set as string */}
                  {form.$('locationRequestFormType.list').options.map(item => {
                    const optionValue = String(item.value);
                    const currentValue = String(form.$('locationRequestFormType.list').value ?? '');

                    return (
                      <FormGroup key={item.id}>
                        <FormControlLabel
                          value={optionValue}
                          label={item.label}
                          control={<Radio checked={optionValue === currentValue} />}
                          onChange={(evt: SyntheticInputEvent<*>) => {
                            form.$('locationRequestFormType.list').set(String(evt.target.value));
                          }}
                        />
                      </FormGroup>
                    );
                  })}
                </FormControl>
              </RequireForAccess>
            )}
          </ActionDrawerBlock>
        </div>

        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.create')} />
      </React.Fragment>
    );
  }
}
